<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ "FLUJOVENTACONSULTAS.LBL_CONSULTAS" | translate }}</label>
          <p-dropdown disableTab
            id="idListaIntegracion{{ fluVentaPaso.codigo }}"
            name="nomIdListaIntegracion{{ fluVentaPaso.codigo }}"
            [options]="lisIntegracionesSelect"
            filter="filter"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
            formControlName="idListaIntegracion"
          ></p-dropdown>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idListaIntegracion.invalid"
          >
            {{ "FLUJOVENTACONSULTAS.LBL_CONSULTAS" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- VINCULACIONES -->
      <div
        class="col-12 md:col-6 lg:col-6"
        *ngIf="f.indicadorConsultaVinculacion.value"
      >
        <div class="div-form">
          <label
            >* {{ "FLUJOVENTACONSULTAS.LBL_VINCULACIONES" | translate }}</label
          >
          <p-multiSelect
            id="idsVinculaciones"
            name="idsVinculaciones"
            [options]="listaVinculaciones"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{
              'LBL_ELEMENTOSSELECCIONADOS' | translate
            }}"
            formControlName="idsVinculaciones"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          >
          </p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsVinculaciones.invalid"
          >
            {{ "FLUJOVENTACONSULTAS.LBL_VINCULACIONES" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <!-- OCUPACION -->
      <div
        class="col-12 md:col-6 lg:col-6"
        *ngIf="f.indicadorOcupacion.value"
      >
        <div class="div-form">
          <label
          >* {{ "FLUJOVENTACONSULTAS.LBL_OCUPACION" | translate }}</label
          >
          <p-multiSelect
            id="idsOcupaciones"
            name="idsOcupaciones"
            [options]="listasTiposOcupaciones"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{
              'LBL_ELEMENTOSSELECCIONADOS' | translate
            }}"
            formControlName="idsOcupaciones"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          >
          </p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsOcupaciones.invalid"
          >
            {{ "FLUJOVENTACONSULTAS.LBL_OCUPACION" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <p-checkbox
            label="{{ 'FLUJOVENTACONSULTAS.LBL_SOLICITUD' | translate }}"
            binary="true"
            id="indicadorSolicitud{{ fluVentaPaso.codigo }}"
            name="nomIndicadorSolicitud{{ fluVentaPaso.codigo }}"
            formControlName="indicadorSolicitud"
          ></p-checkbox>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && invalidDependentFields"
          >
            {{ "FLUJOVENTACONSULTAS.LBL_SOLICITUD" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <p-checkbox
            label="{{ 'FLUJOVENTACONSULTAS.LBL_GT' | translate }}"
            binary="true"
            id="indicadorGestorTerceros{{ fluVentaPaso.codigo }}"
            name="nomIndicadorGestorTerceros{{ fluVentaPaso.codigo }}"
            formControlName="indicadorGestorTerceros"
          ></p-checkbox>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && invalidDependentFields"
          >
            {{ "FLUJOVENTACONSULTAS.LBL_GT" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <p-checkbox
            label="{{ 'FLUJOVENTACONSULTAS.LBL_HABILITADO' | translate }}"
            binary="true"
            id="indicadorHabilitado{{ fluVentaPaso.codigo }}"
            name="nomIndicadorHabilitado{{ fluVentaPaso.codigo }}"
            formControlName="indicadorHabilitado"
          ></p-checkbox>
        </div>
      </div>

      <!-- INDICADOR CONSULTA POR VINCULACION -->
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <p-checkbox
            label="{{
              'FLUJOVENTACONSULTAS.LBL_CONSULTAPORVINCULACION' | translate
            }}"
            binary="true"
            id="indicadorConsultaVinculacion{{ fluVentaPaso.codigo }}"
            name="indicadorConsultaVinculacion{{ fluVentaPaso.codigo }}"
            formControlName="indicadorConsultaVinculacion"
            (onChange)="consultaPorVinculacion()"
          ></p-checkbox>
        </div>
      </div>

      <!-- INDICADOR CONSULTA POR OCUPACION -->
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <p-checkbox
            label="{{
              'FLUJOVENTACONSULTAS.LBL_CONSULTAPOROCUPACION' | translate
            }}"
            binary="true"
            id="indicadorConsultaOcupacion{{ fluVentaPaso.codigo }}"
            name="indicadorConsultaOcupacion{{ fluVentaPaso.codigo }}"
            formControlName="indicadorOcupacion"
            (onChange)="validarOcupacionObligatorio($event.checked)"
          ></p-checkbox>
        </div>
      </div>
    </div>

    <div class="grid form-group"></div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button
        *ngIf="!editando"
          icon="fa fa-plus"
          label="{{ 'BTN_AGREGAR' | translate }}"
          type="submit"
          pButton
        ></button>
        <button
        *ngIf="editando"
          icon="fa fa-plus"
          label=" {{ 'BTN_MODIFICAR' | translate }}"
          type="submit"
          pButton
        ></button>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6"></div>
    <div class="col-12 md:col-6 lg:col-6">
      <input
        type="text"
        pInputText
        size="40"
        placeholder="{{ 'LBL_BUSCAR' | translate }}"
        (input)="dt.filterGlobal($event.target.value, 'contains')"
      />
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #dt
        [value]="lisFlujoIntegraciones"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.nombreListaIntegracion }}</td>
            <td>{{ row.codigoListaIntegracion }}</td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorSolicitud"
                binary="true"
                [ngModelOptions]="{ standalone: true }"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorGestorTerceros"
                binary="true"
                [ngModelOptions]="{ standalone: true }"
                disabled="true"
              ></p-checkbox>
            </td>
            <td>{{row.flujoVentaPasosIntegracionVinculacionTextoCorto}} <span *ngIf="row.verCompletoflujoVentaPasosIntegracionVinculacion" (click)="detalleTabla(row)" style="cursor: pointer;">...</span></td>
            <td>{{row.flujoVentaPasosIntegracionOcupacionesTextoCorto}} <span *ngIf="row.verCompletoflujoVentaPasosOcupaciones" (click)="detalleTablaOcupaciones(row)" style="cursor: pointer;">...</span></td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorHabilitado"
                binary="true"
                [ngModelOptions]="{ standalone: true }"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  (click)="editar(row)"
                ></button>
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhablitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td class="text-center" [attr.colspan]="columns.length">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="flujoVentaIntegracion{{ fluVentaPaso.codigo }}">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<!-- DIALOGO DETALLE TABLA -->
<p-dialog id="dlgCausales"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"

          *ngIf="detalle"
          [(visible)]="detalle"
          [contentStyle]="{'width':'600px', 'overflow-y': 'auto', 'max-height': '350px', 'overflow-x': 'auto'}"
          [header]="tituloDetalle"
          [modal]="true">

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        {{textoDetalle}}
      </div>
    </div>
  </div>
</p-dialog>
